<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.topicName" clearable placeholder="话题名称"></el-input>
        <el-select v-model="queryParam.topicType" placeholder="话题类型" filterable style="width:200px;margin-right:10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.topicType)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.isEnable" placeholder="状态" filterable style="width:200px;margin-right:10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.isEnable)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <!--        <el-date-picker v-model="queryParam.addTime" type="datetime" format="yyyy-MM-dd HH:mm" placeholder="注册时间"></el-date-picker>-->
        <el-button style="margin-left: 10px;" @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="queryParam=JSON.parse(JSON.stringify(oldQueryParam))" type="default">重置</el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium">
        <el-table-column prop="topicName" label="话题"></el-table-column>
        <el-table-column prop="postCount" label="动态数"></el-table-column>
        <el-table-column prop="topicType" label="话题类型">
          <template slot-scope="scope">
            {{$enums.topicType[scope.row.topicType]}}
          </template>
        </el-table-column>
        <el-table-column prop="isEnable" label="状态">
          <template slot-scope="scope">
            {{$enums.isEnable[scope.row.isEnable]}}
          </template>
        </el-table-column>
        <el-table-column prop="logoUrl" label="logo">
          <template slot-scope="scope">
            <div>
              <el-image v-if="scope.row.logoUrl" :src="scope.row.logoUrl" :preview-src-list="[scope.row.logoUrl]" style="width: 50px;height: 50px;"></el-image>
            </div>
            <el-upload v-if="scope.row.topicType == 0" class="inline-block" action="" :http-request="uploadOSS1" :data="scope.row" :show-file-list="false" :before-upload="beforeAvatarUpload"
                       accept=".png,.jpg,.gif">
              <el-button type="text" style="color: #1890FF;margin-left: 0px;">上传logo</el-button>
            </el-upload>
          </template>
        </el-table-column>
        <el-table-column prop="backUrl" label="背景图">
          <template slot-scope="scope">
            <div>
              <el-image v-if="scope.row.backUrl" :src="scope.row.backUrl" :preview-src-list="[scope.row.backUrl]" style="width: 50px;height: 50px;"></el-image>
            </div>
            <el-upload v-if="scope.row.topicType == 0" class="inline-block" action="" :http-request="uploadOSS2" :data="scope.row" :show-file-list="false" accept=".png,.jpg,.gif">
              <el-button type="text" style="color: #1890FF;margin-left: 0px;">上传背景图</el-button>
            </el-upload>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="edit(scope.row)">修改话题类型</el-button>
            <el-button v-if="scope.row.isRecommend == 1" size="mini" style="color: #E91212;" type="text" @click="cancel(scope.row)">取消推荐话题</el-button>
            <el-button v-if="scope.row.isRecommend == 0" size="mini" type="text" @click="recommend(scope.row)">设置推荐话题</el-button>
            <el-button v-if="scope.row.isEnable == 1" size="mini" type="text" style="color: #E91212;" @click="forbid(scope.row)">屏蔽</el-button>
            <el-button v-if="scope.row.isEnable == 0" size="mini" type="text" @click="unforbid(scope.row)">取消屏蔽</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog title="修改话题类型" v-if="editForm.show" :visible.sync="editForm.show" width="600px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <EditTopic :row="editForm.row" @close="getPage()"></EditTopic>
    </el-dialog>
  </div>
</template>
<script>
import EditTopic from './topic-logo-edit'

export default {
  name: 'topic',
  components: { EditTopic },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId, specialtyId: this.$route.query.specialtyId },
      oldQueryParam: {},
      page: { pageSize: 20, pageNum: 1 },
      editForm: { show: false, row: null },
      batchList: [],
      specialtyList: []
    }
  },
  async created () {
    await this.getPage()
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async uploadOSS1 (event) {
      try {
        if (event.file.size > 1024 * 1024 * 2) {
          throw new Error('仅支持JPG、PNG、GIF格式图片文件，且文件大小小于2MB')
        }
        let url = await this.$HTTP.ApiOss.uploadOSS(event.file, `artcircle`, '.png,.jpg,.gif', 'public-read')
        await this.$HTTP.ApiTopic.getTopicInfo({ topicId: event.data.id, logoUrl: url, thumbLogoUrl: url })
        await this.getPage()
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async uploadOSS2 (event) {
      try {
        if (event.file.size > 1024 * 1024 * 2) {
          throw new Error('仅支持JPG、PNG、GIF格式图片文件，且文件大小小于2MB')
        }
        let url = await this.$HTTP.ApiOss.uploadOSS(event.file, `artcircle`, '.png,.jpg,.gif', 'public-read')
        await this.$HTTP.ApiTopic.getTopicInfo({ topicId: event.data.id, backUrl: url })
        await this.getPage()
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async getPage (queryParam) {
      try {
        this.editForm.show = false
        this.editForm.row = null
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiTopic.getPageInfo(this.queryParam)
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async edit (row) {
      try {
        this.editForm.show = true
        if (row) {
          this.editForm.row = row
        } else {
          this.editForm.row = null
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async recommend (item) {
      if (item) {
        await this.$HTTP.ApiTopic.setRecommend(item.id)
        this.$message({ type: 'success', message: '操作成功' })
        await this.getPage()
      } else {
        this.$message({ type: 'error', message: '操作失败' })
      }
    },
    async cancel (item) {
      if (item) {
        await this.$HTTP.ApiTopic.cancelRecommend(item.id)
        this.$message({ type: 'success', message: '操作成功' })
        await this.getPage()
      } else {
        this.$message({ type: 'error', message: '操作失败' })
      }
    },
    async forbid (item) {
      if (item) {
        await this.$HTTP.ApiTopic.setForbid(item.id)
        this.$message({ type: 'success', message: '操作成功' })
        await this.getPage()
      } else {
        this.$message({ type: 'error', message: '操作失败' })
      }
    },
    async unforbid (item) {
      if (item) {
        await this.$HTTP.ApiTopic.cancelForbid(item.id)
        this.$message({ type: 'success', message: '操作成功' })
        await this.getPage()
      } else {
        this.$message({ type: 'error', message: '操作失败' })
      }
    },
    beforeAvatarUpload (file) {
      let _this = this
      return new Promise((resolve, reject) => {
        let isLt2M = file.size / 1024 / 1024 < 10 // 判定图片大小是否小于10MB
        if (!isLt2M) {
          reject()
        }
        let image = new Image(), resultBlob = ''
        image.src = URL.createObjectURL(file)
        image.onload = () => {
          // 调用方法获取blob格式，方法写在下边
          resultBlob = _this.compressUpload(image, file)
          resolve(resultBlob)
        }
        image.onerror = () => {
          reject()
        }
      })
    },
    /* 图片压缩方法-canvas压缩 */
    compressUpload (image, file) {
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      let initSize = image.src.length
      console.log(initSize)
      let { width } = image, { height } = image
      canvas.width = width
      canvas.height = height
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(image, 0, 0, width, height)

      // 进行最小压缩0.1
      let compressData = canvas.toDataURL(file.type || 'image/jpeg', 0.1)
      // 压缩后调用方法进行base64转Blob，方法写在下边
      let blobImg = this.dataURItoBlob(compressData)
      return blobImg
    },
    /* base64转Blob对象 */
    dataURItoBlob (data) {
      let byteString
      if (data.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(data.split(',')[1])
      } else {
        byteString = unescape(data.split(',')[1])
      }
      let mimeString = data
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]
      let ia = new Uint8Array(byteString.length)
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], { type: mimeString })
    }
  }
}
</script>
